exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".list-group-item[data-v-4b0efa00]{cursor:pointer}.btn[data-v-4b0efa00]{border-radius:8px}.btn[data-v-4b0efa00]:disabled{pointer-events:none}h5[data-v-4b0efa00]{font-weight:600}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4b0efa00","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/components/News.vue
// module id = k8h0
// module chunks = 0